import { render } from "./CourseIntroductionCard.vue?vue&type=template&id=636a0daf&scoped=true"
import script from "./CourseIntroductionCard.vue?vue&type=script&lang=js"
export * from "./CourseIntroductionCard.vue?vue&type=script&lang=js"

import "./CourseIntroductionCard.vue?vue&type=style&index=0&id=636a0daf&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636a0daf"]])

export default __exports__